import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import { AnalyticsCategoryProvider, Categories } from '@app/analytics';
import { CenteredLoader, PublicBackground } from '@app/core';
import { StudySubjectPreference, useMe } from '@app/api';
import { StudyPreferences } from '../StudyApplication/StudyPreferences';

export const Preferences = () => {
  const navigate = useNavigate();
  const { data: me, isLoading } = useMe();

  if (isLoading) {
    return <CenteredLoader />;
  }

  if (!me) {
    return <Navigate to="login" />;
  }

  return (
    <AnalyticsCategoryProvider category={Categories.ADD_PANEL_INFO}>
      <PublicBackground>
        <StudyPreferences
          participantId={me.linkedParticipants[0]}
          onSuccess={() => navigate(`/onboarding`)}
        />
      </PublicBackground>
    </AnalyticsCategoryProvider>
  );
};
